import { toast } from "@starline-security/component-library";

export default {
  namespaced: true,

  state: {
    errors: [],
    openModal: false,
    labelText: false,
    editText: false,
  },

  getters: {
    errors(state) {
      return state.errors;
    },

    openModal(state) {
      return state.openModal;
    },

    labelText(state) {
      return state.labelText;
    },

    textEdit(state) {
      return state.editText;
    },
  },

  mutations: {
    updateErrors(state, payload) {
      state.errors = payload;
    },

    closeModal(state) {
      state.errors = [];
      state.openModal = false;
    },

    labelText(state, payload) {
      state.labelText = payload;
    },

    textEdit(state, payload) {
      state.editText = payload;
    },

    openModal(state, payload) {
      if (Array.isArray(payload)) {
        for (let key in payload) {
          for (let i = 0; i < payload[key].length; i++) {
            state.errors.push(payload[key][i]);
          }
        }
      } else {
        if (_.isObject(payload)) {
          Object.values(payload).forEach((error) => {
            state.errors.push(error);
          });
        } else {
          state.errors.push(payload);
        }
      }

      //  const msg = `Unknown error happened and has been logged with us. We will aim to
      //     resolve this issue as soon as possible. Our apologies for
      //     inconvenience`;

      state.errors?.forEach((ee) => {
        if (Array.isArray(ee)) {
          const m = ee.join(", ");
          toast.error(m);
        } else {
          toast.error(ee);
        }
      });

      state.errors = [];

      // state.openModal = true;
    },
  },

  actions: {},
};
